import React, { useContext, useState, useMemo } from "react";
import {
	BusFareDepartContext,
	BusFareReturnContext,
	LoyaltyDiscountContext,
} from "../UserContext";
import {
	calculateLoyaltyPointsToEarn,
	checkIsReschedule,
	getUserPrimaryEmail,
	sessionStorageGetItem,
} from "./Function";
import { LoginSignUpModal } from "./LoginSignUpModal";
import "./SignInToCollectLoyalty.css";

export const SignInToCollectLoyalty = ({ manjaRewards = {}, login }) => {
	// contexts (kept for consistency / future use)
	useContext(BusFareDepartContext);
	useContext(BusFareReturnContext);
	const { TotalLoyalty } = useContext(LoyaltyDiscountContext);

	/* -----------------------------
	 * Safe storage reads
	 * ----------------------------- */
	const rawAddOn = sessionStorageGetItem("addOn");
	const rawBusFare = sessionStorageGetItem("busFare");

	const BusFareAddOn = useMemo(() => {
		try {
			const parsed = JSON.parse(rawAddOn || "[]");
			return Array.isArray(parsed) ? parsed : [];
		} catch {
			return [];
		}
	}, [rawAddOn]);

	const baseBusFare = useMemo(() => {
		try {
			return Number(JSON.parse(rawBusFare || "0")) || 0;
		} catch {
			return 0;
		}
	}, [rawBusFare]);

	/* -----------------------------
	 * Fare calculation
	 * ----------------------------- */
	const totalAddOn = useMemo(
		() =>
			BusFareAddOn.reduce(
				(sum, x) => sum + (Number(x?.sub_totalPrice) || 0),
				0
			),
		[BusFareAddOn]
	);

	const payableFare = Math.max(
		0,
		baseBusFare + totalAddOn - (Number(TotalLoyalty) || 0)
	);

	/* -----------------------------
	 * Loyalty logic
	 * ----------------------------- */
	const isReschedule = checkIsReschedule();
	const earnPoints = calculateLoyaltyPointsToEarn(
		isReschedule ? 0 : payableFare
	);

	const email = getUserPrimaryEmail();
	const balancePoints =
		manjaRewards?.points != null && manjaRewards?.points !== ""
			? manjaRewards.points
			: 0;

	/* -----------------------------
	 * Modal state
	 * ----------------------------- */
	const [showModal, setShowModal] = useState(false);
	const [modalKey, setModalKey] = useState(0);

	const openModal = () => {
		// unmount any old modal instance, then remount fresh
		setShowModal(false);
		setTimeout(() => {
			setModalKey((k) => k + 1);
			setShowModal(true);
		}, 0);
	};

	const closeModal = () => setShowModal(false);

	// const openModal = () => setShowModal(true);
	// const closeModal = () => setShowModal(false);

	/* =============================
	 * LOGGED IN VIEW
	 * ============================= */
	if (login === true) {
		return (
			<div className="loyaltyCard">
				<div className="loyaltyTop">
					<div>
						<div className="loyaltyKicker">Manja Rewards</div>
						<div className="loyaltyTitle">You’re signed in</div>
						<div className="loyaltySub">{email}</div>
					</div>

					<div className="loyaltyPill">
						<div className="loyaltyPillLabel">Balance</div>
						<div className="loyaltyPillValue">{balancePoints} pts</div>
					</div>
				</div>

				<div className="loyaltyDivider" />

				<div className="loyaltyBottom">
					<div className="loyaltyEarnRow">
						<div className="loyaltyEarnChip">
							+{earnPoints.toFixed()} pts
						</div>
						<div className="loyaltyEarnText">
							You’ll earn points from this booking after successful payment.
						</div>
					</div>
				</div>
			</div>
		);
	}

	/* =============================
	 * NOT LOGGED IN (CTA) VIEW
	 * ============================= */
	return (
		<>
			{showModal && (
				<LoginSignUpModal key={modalKey} show={showModal} onHide={closeModal} />
			)}

			{/* {showModal && (
				<LoginSignUpModal show={showModal} onHide={closeModal} />
			)} */}

			<div className="loyaltyCard loyaltyCardCta">
				<div className="loyaltyTop">
					<div>
						<div className="loyaltyKicker">Manja Rewards</div>
						<div className="loyaltyTitle">Earn points for this booking</div>
						<div className="loyaltySub">
							Sign in to collect{" "}
							<span className="loyaltyInlinePoints">
								{earnPoints.toFixed()}
							</span>{" "}
							points now.
						</div>
					</div>

					<button
						className="loyaltyBtn"
						type="button"
						onClick={openModal}
					>
						Sign in
					</button>
				</div>

				<div className="loyaltyHint">
					Tip: Use the same email you used for previous bookings to keep all
					points in one account.
				</div>
			</div>
		</>
	);
};
